<script setup lang="ts">
import {GiftPalette} from "@/birthday-gift/interfaces";
import {GIFT_PALETTES} from "@/birthday-gift/constants/palettes";

defineProps<{
    modelValue: GiftPalette;
}>();

const emit = defineEmits<{
    (e: 'update:modelValue', value: GiftPalette): void;
}>();

const palettes = Object.entries(GIFT_PALETTES) as [GiftPalette, typeof GIFT_PALETTES[GiftPalette]][];
</script>

<template>
  <div class="flex flex-wrap gap-2">
    <button
      v-for="[id, palette] in palettes"
      :key="id"
      type="button"
      :title="palette.label"
      :aria-label="palette.label"
      :aria-pressed="modelValue === id"
      class="flex h-9 w-9 items-center justify-center rounded-lg border-2 border-solid"
      :class="modelValue === id ? 'border-primary' : 'border-transparent'"
      :style="{background: palette.tint}"
      @click="emit('update:modelValue', id)"
    >
      <component
        :is="palette.icon"
        class="h-4 w-4"
        :style="{color: palette.iconColor}"
      />
    </button>
  </div>
</template>
